// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__MY7HR","Open":"SideDrawer_Open__1dWBU","Close":"SideDrawer_Close__2GTQm"};